import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=073a3d55&scoped=true"
import script from "./Sports.vue?vue&type=script&lang=js"
export * from "./Sports.vue?vue&type=script&lang=js"
import style0 from "./Sports.vue?vue&type=style&index=0&id=073a3d55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a3d55",
  null
  
)

export default component.exports